module.exports = __webpack_public_path__ + "img/weddingRingsMorningGlow-emotion-03.272ae95.webp";